import Vue from 'vue'
import Router from 'vue-router'
import Home from '@/components/Home'
import SectorDetails from '@/components/SectorDetails'

import Confirmation from '@/components/Confirmation'
import RouteDetails from '@/components/Routes/RouteDetails'
import QRcode from '@/components/Routes/QRcode'

import RouteLog from '@/components/User/RouteLog'
import GuestRating from '@/components/User/GuestRating'
import RouteClimbed from '@/components/User/RouteClimbed'
import Booking from '@/components/User/Booking'
// import GymRouteList from '@/components/User/GymRouteList'

import Gymlist from '@/components/User/Gymlist'
import GymEdit from '@/components/User/GymEdit'
import GymAdd from '@/components/User/GymAdd'
import GymDashboard from '@/components/User/GymDashboard'

const RouteList = () => import(/* webpackChunkName: 'routelist' */ '@/components/Routes/RouteList')
const Help = () => import(/* webpackChunkName: 'help' */ '@/components/Information/Help')
const Provider = () => import(/* webpackChunkName: 'provider' */ '@/components/Information/Provider')
const Policy = () => import(/* webpackChunkName: 'policy' */ '@/components/Information/Policy')
const Info = () => import(/* webpackChunkName: 'info' */ '@/components/Information/Info')
const Scan = () => import(/* webpackChunkName: 'scan' */ '@/components/Scan')

import RoutesAdd from '@/components/Test/RoutesAdd'

Vue.use(Router)

export default new Router({
  mode: 'hash',
  // *** mode: history - removes # from url *** out so when reload components returns to home
  routes: [
    { path: '/',
      name: 'home',
      component: Home,
      meta: {
        title: 'Home Page - tendu',
        metaTags: [
          {
            name: 'Description',
            content: 'Easily find routes you want to climb in a climbing-gym.'
          }
        ]
      },
      props: {
        default: false
      }
    },
    { path: '/RoutesAdd',
      name: 'routesadd',
      component: RoutesAdd
    },

    { path: '/Scan',
      name: 'scan',
      component: Scan
    },

    { path: '/SectorDetails',
      name: 'sectordetails',
      component: SectorDetails
    },

    { path: '/RouteList/:sectorId',
      name: 'routelist',
      component: RouteList,
      props: { default: true }
    },

    { path: '/RouteDetails',
      name: 'routedetails',
      component: RouteDetails
    },

    { path: '/QRcode/:sectorId(\\d+)/:routeId(\\d+)',
      name: 'qrcode',
      component: QRcode,
      props: { default: true, name: 'QRcode'}
    },

    { path: '/confirmation/:token/:option',
      name: 'confirmation',
      component: Confirmation,
      props: { default: true }
    },

    { path: '/RouteClimbed',
      name: 'routeclimbed',
      component: RouteClimbed
    },

    { path: '/GuestRating',
      name: 'guestrating',
      component: GuestRating
    },

    { path: '/RouteLog',
      name: 'routelog',
      component: RouteLog
    },

    { path: '/GymDashboard',
      name: 'gymdashboard',
      component: GymDashboard
    },

    { path: '/Gymlist',
      name: 'gymlist',
      component: Gymlist
    },

    { // path: '/GymEdit/',
      path: '/GymEdit/:sectorId(\\d+)/:routeId(\\d+)',
      name: 'gymedit',
      component: GymEdit,
      props: { default: true, name: 'GymEdit'}
    },

    { path: '/GymAdd',
      name: 'gymeadd',
      component: GymAdd
    },

    { path: '/Help',
      name: 'help',
      component: Help
    },

    { path: '/Provider',
      name: 'provider',
      component: Provider
    },

    { path: '/Policy',
      name: 'policy',
      component: Policy
    },

    { path: '/Info',
      name: 'info',
      component: Info
    },
    { path: '/Booking',
      name: 'booking',
      component: Booking
    },

  ],


  scrollBehavior (to, from, savedPosition) {
    if (savedPosition) {
      // Keep scroll position when using browser buttons
      return savedPosition
    } else {
      return { x: 0, y: 0 }
    }
  }
})
